import React from 'react';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import {
  TableRow,
  ItemTitle,
  ItemDescription,
} from 'components/tables/ItemsTable/styledComponents';

export default function TableDetails({ title, description, rows, children, lastLineWidth }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <tbody>
        <TableRow withDescription={!!description}>
          {title && (
            <td>
              <div onClick={() => setOpen((open) => !open)}>
                {open && <ArrowDown style={{ marginBottom: '-5px' }} />}
                {!open && <ArrowRight style={{ marginBottom: '-5px' }} />}{' '}
                <ItemTitle color="secondary">{title}</ItemTitle>
              </div>
            </td>
          )}
          {rows.map((row, index) => (
            <td
              style={rows.length - 1 === index ? { width: lastLineWidth } : undefined}
              key={index}
            >
              <div>{row}</div>
            </td>
          ))}
        </TableRow>
        {description && <ItemDescription color="textDark">{description}</ItemDescription>}
      </tbody>
      {(!title || open) && <tbody>{children}</tbody>}
    </>
  );
}
